import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { Folder } from '@estimator/shared';

interface FoldersResponse {
  data: Folder[];
  unfiled_count: number;
}

export function useFolders(projectId: string, parentId?: string | 'root') {
  return useQuery<FoldersResponse>({
    queryKey: ['folders', projectId, parentId ?? 'all'],
    queryFn: async () => {
      const params = parentId !== undefined ? `?parentId=${parentId}` : '';
      const { data } = await apiClient.get<FoldersResponse>(
        `/projects/${projectId}/folders${params}`,
      );
      return data;
    },
    enabled: !!projectId,
  });
}
